import { useState, useEffect } from "react";
import withRole from "../../Hooks/withRole";
import genericStyles from "../../Styles/genericStyles.module.css";
import { ETableEditAction } from "../../Utils/Enums";
import { endpoints } from "../../Utils/UrlEnum";
import { Vocabulary } from "../../Utils/Vocabulary";
import MUIDataTableCustomStyle from "../MUIDataTableCustomStyle";
import GenericModal from "../GenericModal";
import DocumentTemplateForm from "./DocumentTemplateForm";
import { Button } from "@mui/material";
import { FormsIds } from "../../Utils/Constants";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import FilePreview from "../../Utils/FilePreview";
import { fetchDocumentTypes } from "../../Utils/DocumentTypesUtils";

/**
 * DocumentTemplatesTable component renders a table of document templates
 * with various columns including name, type, and other relevant information.
 * It utilizes the MUIDataTableCustomStyle component to display data and
 * provides functionalities for adding and editing document template entries through a modal form.
 * State is managed for contextValue, form visibility, and table data reload triggers.
 */

function DocumentTemplatesTable() {
  const [contextValue, setContextValue] = useState({});
  const [openForm, setOpenForm] = useState(false);
  const [triggerReload, setTriggerReload] = useState(false);
  const [documentTypes, setDocumentTypes] = useState<any[]>([]);

  useEffect(() => {
    const loadDocumentTypes = async () => {
      const types = await fetchDocumentTypes();
      setDocumentTypes(types);
    };
    loadDocumentTypes();
  }, []);

  /**
   * Columns definition for MUIDataTable component
   */
  const columns = [
    {
      name: "name",
      label: Vocabulary.name,
    },
    {
      name: "type",
      label: Vocabulary.type,
      options: {
        customBodyRender: (type: any) => {
          return Vocabulary[type];
        },
      },
    },
    {
      name: "template",
      label: Vocabulary.template,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (fileName: any) => {
          if (fileName === null) return null;
          //   const path = `${urlEnum.vehicles}/${fileName}`;
          return (
            <Button
              size="small"
              color="primary"
              variant="contained"
              data-file={`/${fileName}`}
            >
              {Vocabulary.download}
            </Button>
          );
        },
      },
    },
  ];

  /***
   * Render
   */
  return (
    <div className={genericStyles.mainContainer}>
      <MUIDataTableCustomStyle
        onEditAction={ETableEditAction.MODAL}
        title={Vocabulary.documentTemplates}
        columns={columns}
        CRUDEndPoint={endpoints.documentTemplates}
        setContextValue={setContextValue}
        selectableRows={"none"}
        triggerReload={triggerReload}
        handleModalForm={setOpenForm}
        addOrEditForm={
          <GenericModal
            title={Vocabulary.documentTemplates}
            open={openForm}
            onClose={() => {
              setContextValue({});
              setOpenForm(false);
            }}
            children={
              <DocumentTemplateForm
                onClose={() => {
                  setContextValue({});
                  setOpenForm(false);
                  setTriggerReload(!triggerReload);
                }}
                selectedRow={contextValue}
                documentTypes={documentTypes}
              />
            }
            actions={
              <div className={genericStyles.editClientModalEditButton}>
                <Button
                  color="error"
                  variant="contained"
                  onClick={() => setOpenForm(false)}
                  startIcon={<CancelIcon />}
                >
                  {Vocabulary.cancel}
                </Button>
                <Button
                  variant="contained"
                  type="submit"
                  form={FormsIds.documentTemplateForm}
                  color="success"
                  startIcon={<SaveIcon />}
                >
                  {Vocabulary.save}
                </Button>
              </div>
            }
          />
        }
      />
      <FilePreview />
    </div>
  );
}

export default withRole(DocumentTemplatesTable);
